import type {
  CharacterDefinition,
  CharacterId,
  WorldId,
  WorldTheme,
} from "./types";

export const CHARACTERS = {
  dragon: {
    id: "dragon",
    displayName: "דרקונית האש",
    worldId: "volcano",
    projectile: "fireball",
    projectileName: "כדור אש קסום",
    accessibilityLabel: "דרקונית סגולה שיורה כדורי אש קסומים",
  },
  unicorn: {
    id: "unicorn",
    displayName: "חדת הקרן",
    worldId: "rainbow",
    projectile: "rainbow-beam",
    projectileName: "קרן קשת בענן",
    accessibilityLabel: "חדת קרן לבנה שיורה קרן קשת בענן",
  },
} as const satisfies Record<CharacterId, CharacterDefinition>;

export const WORLD_THEMES = {
  volcano: {
    id: "volcano",
    characterId: "dragon",
    displayName: "עמק הרי הגעש",
    palette: {
      sky: "#442052",
      ground: "#38223f",
      primary: "#ef6a4c",
      secondary: "#ffbd59",
      accent: "#c37bff",
      danger: "#e84545",
    },
    scenery: ["basalt", "cave", "volcano", "lava", "fire-crystal"],
    hazards: ["lava", "fall"],
    enemies: ["little-knight", "young-dragon", "knight-mage"],
    rareCollectibleName: "אודם אש",
    celebration: "זיקוקי כוכבים מעל הר הגעש",
  },
  rainbow: {
    id: "rainbow",
    characterId: "unicorn",
    displayName: "גני הקשת",
    palette: {
      sky: "#aee9ff",
      ground: "#79cf9f",
      primary: "#ff79bb",
      secondary: "#8d7cff",
      accent: "#ffd866",
      danger: "#7954a8",
    },
    scenery: ["rainbow", "cloud", "heart", "star", "light-path"],
    hazards: ["fall", "storm-cloud"],
    enemies: ["playful-goblin", "friendly-ghost", "ghost-mage"],
    rareCollectibleName: "יהלום קשת",
    celebration: "קשת ענקית וגשם לבבות",
  },
} as const satisfies Record<WorldId, WorldTheme>;

export function getCharacterDefinition(id: CharacterId): CharacterDefinition {
  return CHARACTERS[id];
}

export function getWorldTheme(id: WorldId): WorldTheme {
  return WORLD_THEMES[id];
}

export function getThemeForCharacter(id: CharacterId): WorldTheme {
  return WORLD_THEMES[CHARACTERS[id].worldId];
}

export function isCharacterId(value: unknown): value is CharacterId {
  return value === "dragon" || value === "unicorn";
}
